import { useQuery } from "react-query";
import { useAgentsHttp } from "../useAgentsHttp";
import type { AgentRun } from "../models/run";

// Read one agent run by (project_id, run_id). Backend route is
// `POST /runs/get` (Lambdalith). The storage layer keys on the pair
// so the same run_id under a different project does not return.
interface RunGetResponse {
  run: AgentRun;
}

const QUERY_KEY = "inrange-agents-run-get";

export const useRun = (project_id?: string, run_id?: string) => {
  const http = useAgentsHttp();
  const enabled = Boolean(project_id) && Boolean(run_id);
  return useQuery<AgentRun>(
    [QUERY_KEY, project_id ?? null, run_id ?? null],
    async () => {
      const resp = await http<RunGetResponse>("/runs/get", {
        project_id,
        run_id,
      });
      return resp.run;
    },
    {
      enabled,
      refetchOnWindowFocus: false,
      // Runs are immutable once persisted - cache aggressively.
      staleTime: 10 * 60_000,
    },
  );
};
